<template>
  <div class="second-box">
    <div v-if="!subscription">Loading</div>

    <template v-else-if="currentPeriod">
      <Grid gaf="column" justify-content="space-between" class="text-secondary-1">
        <div class="text-heading-5 text-uppercase">
          {{ currentPeriod.one_time_purchase ? 'One time purchase' : 'Current period' }}
        </div>
        <div class="text-body-3" :class="{ 'text-grey3': currentPeriod.status.name === 'cancelled' }">
          {{ dateToDisplay }}
        </div>
      </Grid>

      <LineSeparator horizontal />

      <CancelledPeriod v-if="currentPeriod.status.name === 'cancelled'" class="q-pt-sm" @click="undoCancel" />

      <template v-else>
        <ClaimDialog ref="claimDialog" :subscription="subscription" :period="currentPeriod" />

        <Grid gaf="column" justify-content="space-between">
          <div class="text-secondary-1">
            <div v-if="currentPeriod.normalized_price" class="text-heading-1">
              {{ currentPeriod.normalized_currency }}
              {{ formatPrice(currentPeriod.normalized_price, 2) }}
            </div>

            <div v-else class="text-body-3 text-grey3 q-mt-sm">
              {{ currentPeriod.normalized_currency }}
              N/A
            </div>

            <div v-if="currentPeriod.price" class="text-heading-5">
              {{ currentPeriod.currency }}
              {{ formatPrice(currentPeriod.price, 2) }}
            </div>

            <div v-else class="text-body-3 text-grey3">
              {{ currentPeriod.currency }}
              N/A
            </div>

            <div class="text-body-1 text-grey3 q-pt-sm">{{ currentPeriod.name_reference }}</div>
          </div>

          <Grid gap="var(--r-space-sm)" gtr="repeat(3, minmax(0, 1fr))" justify-items="center">
            <RBtn type="text" size="small" @click="openClaimDialog">Claim</RBtn>

            <div v-if="currentPeriod.status.name === 'accepted'" class="text-caption-3 text-success-1 accepted-text">
              accepted
            </div>

            <RBtn v-else type="primary" size="small" @click="onAccept">Accept</RBtn>
            <RBtn type="tertiary" size="small" @click="onCancel">Cancel</RBtn>
          </Grid>
        </Grid>
      </template>
    </template>

    <Grid v-else content-items="center" place-items="center" class="text-heading-1 text-secondary-1 full-height">
      No current period
    </Grid>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
// Components
import ClaimDialog from './ClaimDialog/ClaimDialog'
import LineSeparator from '@/modules/show-page-subscription/components/LineSeparator'
import CancelledPeriod from '@/modules/show-page-subscription/components/TopBar/CancelledPeriod'

export default {
  components: {
    ClaimDialog,
    LineSeparator,
    CancelledPeriod
  },

  computed: {
    ...mapGetters('subscription-show', ['subscription']),

    currentPeriod() {
      return this.subscription ? this.subscription.current : null
    },

    dateToDisplay() {
      if (!this.currentPeriod) return

      const start = moment(this.currentPeriod.start_date).format('D. MMM YYYY')

      if (this.currentPeriod.one_time_purchase) return start

      let end = 'One time purchase'

      if (!this.currentPeriod.one_time_purchase) {
        end = this.currentPeriod.end_date !== null ? moment(this.currentPeriod.end_date).format('D. MMM YYYY') : 'N/A'
      }

      return `${start} - ${end}`
    },

    periodState() {
      if (!this.currentPeriod) return false
      return this.currentPeriod.active
    }
  },

  methods: {
    ...mapMutations('subscription-show', ['setSubscription', 'updatePeriod']),

    openClaimDialog() {
      this.$refs.claimDialog.openDialog()
    },

    undoCancel() {
      const periodId = this.currentPeriod.id
      apiTo.MODIFY_SUBSCRIPTION_PERIOD(periodId, { accept: true }).then(({ data }) => {
        this.updatePeriod(data.result)
        apiTo.GET_SUBSCRIPTION(this.subscription.id).then(({ data }) => this.setSubscription(data.result))
      })
    },

    notificationAfterAcceptOrCancel(response) {
      this.$store.dispatch(
        'createNotificationToast',
        {
          message: response.messages.default,
          color: response.status
        },
        { root: true }
      )
    },

    onAccept() {
      apiTo.ACCEPT_SUBSCRIPTION_PERIOD(this.currentPeriod.id).then(res => {
        this.$store.commit('subscription-show/updatePeriod', {
          ...this.currentPeriod,
          status: { id: 1, name: 'accepted' }
        })
        this.notificationAfterAcceptOrCancel(res.data)
      })
    },

    onCancel() {
      apiTo.CANCEL_SUBSCRIPTION_PERIOD(this.currentPeriod.id).then(res => {
        this.$store.commit('subscription-show/updatePeriod', {
          ...this.currentPeriod,
          status: { id: 3, name: 'cancelled' }
        })
        this.notificationAfterAcceptOrCancel(res.data)
      })
    }
  }
}
</script>
